import React from "react";
import "../css/CouponWarning.css";
import { Translation } from "react-i18next";

function CouponWarning(props) {
  return (
    <div className={`warning-pop-background ${props.active ? "active" : ""}`}>
      <div className={`warning-pop-content ${props.active ? "active" : ""}`}>
        <div className="warning-pop-head">
          <h2>{props.title}</h2>
          <div className="close-button" onClick={props.cancelEvent}></div>
        </div>
        <div className="warning-pop-body">
          <div style={{ padding: "30px 0" }}>{props.body}</div>
          <div className="warning-buttons">
            <button
              className="warning-submit-button"
              onClick={props.submitEvent}
            >
              <Translation>
                {t => <>{t("checkout.couponPopButton")}</>}
              </Translation>
            </button>
            <button
              className="warning-cancel-button"
              onClick={props.cancelEvent}
            >
              <Translation>
                {t => <>{t("checkout.couponCancelButton")}</>}
              </Translation>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

CouponWarning.defaultProps = {
  title: "",
  body: "",
  active: false,
  submitEvent: () => {},
  cancelEvent: () => {}
};

export default CouponWarning;
